<template>
    <b-modal id="domiciliation-help-modal" title="Comment ça marche ?" ok-only>
        <div class="row">
            <div class="col-auto">
                <img src="../../assets/images/icons/numbers/one.svg" alt="Chiffre 1" width="40" height="40">
            </div>

            <div class="col">
                <h2>Choisissez votre adresse</h2>
                <p>Sélectionnez l'adresse la plus adaptée à votre besoin à Paris.</p>
            </div>
        </div>

        <div class="row">
            <div class="col-auto">
                <img src="../../assets/images/icons/numbers/two.svg" alt="Chiffre 2" width="40" height="40">
            </div>

            <div class="col">
                <h2>Indiquez vos coordonnées</h2>
                <p>Indiquez nous vos cordonnées et le numéro de téléphone sur lequel votre conseiller Assistel pourra vous recontacter.</p>
            </div>
        </div>

        <div class="row">
            <div class="col-auto">
                <img src="../../assets/images/icons/numbers/three.svg" alt="Chiffre 3" width="40" height="40">
            </div>

            <div class="col">
                <h2>Configurez vos options</h2>
                <p>Création d'entreprise, gestion de votre courrier... Choisissez les options dont vous avez besoin.</p>
            </div>
        </div>

        <div class="row">
            <div class="col-auto">
                <img src="../../assets/images/icons/numbers/four.svg" alt="Chiffre 4" width="40" height="40">
            </div>

            <div class="col">
                <h2>Réglez en ligne</h2>
                <p>Et recevez votre contrat dans l'heure !</p>
            </div>
        </div>
    </b-modal>
</template>

<script>
    export default {
        name: 'DomiciliationHelpModal'
    }
</script>
